"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HTTPClient = exports.HTTPClientConfig = void 0;
var isomorphic_fetch_1 = __importDefault(require("isomorphic-fetch")); // eslint-disable-line no-shadow
var AppError_1 = require("./AppError");
var HTTPClientConfig = /** @class */ (function () {
    function HTTPClientConfig() {
        this.baseURL = '';
        this.accessToken = '';
        this.authPrefix = '';
    }
    return HTTPClientConfig;
}());
exports.HTTPClientConfig = HTTPClientConfig;
var createPromise = function () {
    var resolve;
    var reject;
    var promise = new Promise(function (_resolve, _reject) {
        resolve = _resolve;
        reject = _reject;
    });
    promise.resolve = function (result) { return resolve(result); };
    promise.reject = function (error) { return reject(error); };
    return promise;
};
var getBodyAsBuffer = function (response) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!('arrayBuffer' in response)) return [3 /*break*/, 2];
                return [4 /*yield*/, response.arrayBuffer()];
            case 1: return [2 /*return*/, _a.sent()];
            case 2: 
            // Otherwise, fall back to streaming body into a buffer
            // (isomorphic fetch doesnt support this yet: https://github.com/bitinn/node-fetch/issues/51)
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    var chunks = [];
                    response.body.on('error', function (err) { return reject(err); });
                    response.body.on('data', function (chunk) { return chunks.push(chunk); });
                    response.body.on('end', function () { return resolve(Buffer.concat(chunks)); });
                })];
        }
    });
}); };
var HTTPClient = /** @class */ (function () {
    function HTTPClient(config) {
        var _this = this;
        this.config = config;
        this.requestingCB = function (_args) {
            // no op
        };
        this.onRequesting = function (cb) {
            _this.requestingCB = cb;
        };
        this.request = function (_a) {
            var url = _a.url, _b = _a.method, method = _b === void 0 ? 'GET' : _b, data = _a.data, _c = _a.headers, headers = _c === void 0 ? {} : _c, _d = _a.options, options = _d === void 0 ? {} : _d;
            return __awaiter(_this, void 0, void 0, function () {
                var _e, _f, baseURL, accessToken, on401Callback, _g, authPrefix, absoluteURL, requestBody, response, requestPromise, cache, e_1, _h, errorCode, message, details, displayMessage, body, _j;
                return __generator(this, function (_k) {
                    switch (_k.label) {
                        case 0:
                            if (!url) {
                                throw new AppError_1.AppError({
                                    status: 500,
                                    message: 'url is required'
                                });
                            }
                            _e = this.config || {}, _f = _e.baseURL, baseURL = _f === void 0 ? '' : _f, accessToken = _e.accessToken, on401Callback = _e.on401Callback, _g = _e.authPrefix, authPrefix = _g === void 0 ? 'JWT' : _g;
                            absoluteURL = url.startsWith('http') ? url : "".concat(baseURL).concat(url);
                            if (accessToken && !options.anonymous) {
                                headers = __assign(__assign({}, headers), { authorization: "".concat(authPrefix, " ").concat(accessToken) });
                            }
                            if (data) {
                                // would prefer to use `data instanceof FormData` here but in api tests
                                // this produces error "FormData is not defined" (even with lib:dom in tsconfig)
                                if (typeof data === 'object' && data.toString() === '[object FormData]') {
                                    requestBody = data;
                                }
                                else {
                                    headers['content-type'] = headers['content-type'] || 'application/json';
                                    requestBody = JSON.stringify(data);
                                }
                            }
                            _k.label = 1;
                        case 1:
                            _k.trys.push([1, 3, , 4]);
                            requestPromise = createPromise();
                            // let listener know we are making a request without letting that cause us to fail
                            if (!options.anonymous) {
                                try {
                                    this.requestingCB({ url: absoluteURL, method: method, headers: headers, body: requestBody, requestPromise: requestPromise });
                                }
                                catch (e) {
                                    // fail silently
                                }
                            }
                            cache = (options.allowCaching ? 'default' : 'no-store');
                            return [4 /*yield*/, (0, isomorphic_fetch_1.default)(absoluteURL, { method: method, headers: headers, body: requestBody, cache: cache })];
                        case 2:
                            response = _k.sent();
                            requestPromise.resolve({ status: response.status });
                            return [3 /*break*/, 4];
                        case 3:
                            e_1 = _k.sent();
                            /**
                             * Fetch does not throw unless there is a network error or misconfigured CORS headers
                             * A common cause is API Gateway returning a 502 or 504 (which don't include CORS headers)
                             * There is no obvious way to access the information on what the response looks like with
                             * mode: 'cors' enabled, though it appears in the console
                             * See https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch#Checking_that_the_fetch_was_successful
                             */
                            throw new AppError_1.AppError({
                                errorCode: 'fetch.failed',
                                message: "Fetch failed with ".concat(e_1.name, " ").concat(e_1.message, ". ").concat(method, " ").concat(absoluteURL),
                                displayMessage: "We're sorry, we couldn't handle your request. Please try again."
                            });
                        case 4:
                            if (!(response.status === 401 && on401Callback)) return [3 /*break*/, 6];
                            return [4 /*yield*/, on401Callback()];
                        case 5: return [2 /*return*/, _k.sent()];
                        case 6:
                            if (!!response.ok) return [3 /*break*/, 8];
                            return [4 /*yield*/, this.getResponseJSON(response, { method: method, status: response.status, absoluteURL: absoluteURL, ignoreBadJSON: true })];
                        case 7:
                            _h = _k.sent(), errorCode = _h.errorCode, message = _h.message, details = _h.details, displayMessage = _h.displayMessage;
                            throw new AppError_1.AppError({
                                status: response.status,
                                errorCode: errorCode,
                                message: message,
                                displayMessage: displayMessage,
                                details: details
                            });
                        case 8:
                            if (!options.asBuffer) return [3 /*break*/, 10];
                            return [4 /*yield*/, getBodyAsBuffer(response)];
                        case 9:
                            body = _k.sent();
                            return [3 /*break*/, 14];
                        case 10:
                            if (!(response.status !== 204)) return [3 /*break*/, 12];
                            return [4 /*yield*/, this.getResponseJSON(response, { method: method, status: response.status, absoluteURL: absoluteURL })];
                        case 11:
                            _j = _k.sent();
                            return [3 /*break*/, 13];
                        case 12:
                            _j = null;
                            _k.label = 13;
                        case 13:
                            body = _j;
                            _k.label = 14;
                        case 14: return [2 /*return*/, {
                                status: response.status,
                                url: response.url,
                                data: body
                            }];
                    }
                });
            });
        };
        this.getResponseJSON = function (response, _a) {
            var method = _a.method, status = _a.status, absoluteURL = _a.absoluteURL, _b = _a.ignoreBadJSON, ignoreBadJSON = _b === void 0 ? false : _b;
            return __awaiter(_this, void 0, void 0, function () {
                var body, e_2;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _c.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, response.text()];
                        case 1:
                            body = _c.sent();
                            // occasionally we get a 200 with a null body, but we know the api never sends this response, so we are
                            // setting an errorCode we can blocklist (assuming this indicates the request has been aborted)
                            if (!body) {
                                throw new AppError_1.AppError({
                                    errorCode: 'fetch.missingBody',
                                    message: "Received a 200 with no body likely because the request was aborted. ".concat(method, " ").concat(absoluteURL)
                                });
                            }
                            return [2 /*return*/, JSON.parse(body)];
                        case 2:
                            e_2 = _c.sent();
                            // detect if response.text() threw which should only be possible if the request
                            // has been aborted (as the page is reloading)
                            if (e_2.message === 'Failed to fetch') {
                                throw new AppError_1.AppError({
                                    errorCode: 'fetch.failed',
                                    message: "Failed to get the body of the response likely because the request was aborted. ".concat(method, " ").concat(absoluteURL)
                                });
                            }
                            if (ignoreBadJSON) {
                                // doesn't matter if we can't get the body of an error resopnse (s3 returns html we can't parse)
                                return [2 /*return*/, { status: status, message: 'Could not parse the body of the response.' }];
                            }
                            throw new AppError_1.AppError({
                                status: 500,
                                message: "Failed to parse body with error \"".concat(e_2.message, "\". ").concat(status, " ").concat(method, " ").concat(absoluteURL, " ").concat(body || '[no body]')
                            });
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        this.delete = function (url, headers) { return _this.request({ url: url, method: 'DELETE', headers: headers }); };
        this.patch = function (url, data, headers) { return _this.request({ url: url, method: 'PATCH', data: data, headers: headers }); };
        this.post = function (url, data, headers) { return _this.request({ url: url, method: 'POST', data: data, headers: headers }); };
        this.put = function (url, data, headers) { return _this.request({ url: url, method: 'PUT', data: data, headers: headers }); };
        this.get = function (url, headers, options) { return _this.request({ url: url, method: 'GET', headers: headers, options: options }); };
    }
    HTTPClient.inject = function () { return [HTTPClientConfig]; };
    return HTTPClient;
}());
exports.HTTPClient = HTTPClient;
//# sourceMappingURL=HTTPClient.js.map